import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality in production only.
// In development, explicitly unregister to avoid localhost reload loops when sw.js is missing.
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register({
    onSuccess: (_registration) => {
      // console.log('PWA: Service worker registered successfully', registration);
    },
    onUpdate: (_registration) => {
      // console.log('PWA: New content available, reload to update', registration);
      // Could show a notification to user here
    },
  });
} else {
  serviceWorkerRegistration.unregister();
}